import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";

import moment from "moment";
import { Button, Table } from "react-bootstrap";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import FilterComplexPannel from "../../filter/FilterComplexPannel";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";

class LeadToSiteVisitRatioSalesExecutiveWise extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model);
    const userOptions = model.user.options || [];
    const monthOptions = Constants.Months || [];
    this.lead = model.lead;
    this.meeting = model.meeting;
    const leadFields = model.lead.fields;
    const leadKeys = Object.keys(leadFields).filter((key) => ["enquiry_date", "responsible_person"].includes(key));
    this.lFields = {};
    leadKeys.map((key) => this.lFields[key] = leadFields[key]);
    this.lead.fields = this.lFields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      userOptions,
      monthOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",
        value: `~${this.loggedInUserId}~`,
        model_key: 'lead'
      }, {
        field: "enquiry_date",
        condition: "in",
        value: `${moment.utc().startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSSZ')} ~ ${moment.utc().endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSSZ')}`,
        model_key: 'lead'
      }],
      tableData: [],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount() {
    this.fetchApi(this.state.filters, this.onSuccess, this.onFail);
  }

  fetchApi = (filters, onSuccess, onFail) => {
    const body = {
      filters: filters,
      filters: filters,
      modelx: "lead_model",
      modely: "meeting_model",
      x: "l.enquiry_date",
      y: "l.last_meeting_date",
      z: "l.id",
      a: 'l.responsible_person',
      b: 'mt.responsible_person'
    };
    this.setState({ inApiCall: true });
    DailySalesReportAPI.LeadSiteVisitReportMonthWiseRatio(body, onSuccess, onFail);
  };

  onSuccess = (data) => {
    const { tableData, series } = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData, series, exportData, inApiCall: false });
  };

  onFail = (err) => {
    console.log("Failed to fetch data", err);
  };

  parseData = (response) => {
    let selectedUserId, filteredUserOptions;
    // Extract selected user Ids from filters
    this.state.filters.forEach(filter => {
      if (filter.field === 'responsible_person') {
        selectedUserId = filter.value.split(Constants.Opt).filter(Boolean);
      }
    });

    // Filter users based on selected IDs
    filteredUserOptions = this.state.userOptions.filter(user => {
      if (selectedUserId) {
        return selectedUserId.some(id => parseInt(id) === user.value);
      }
      return true;
    });

    // Prepare table data
    const tableData = this.state.monthOptions.map((month) => {
      const row = { month: month.label };

      filteredUserOptions.forEach((user) => {
        const userId = `~${user.value}~`;

        // Count Leads for the user
        const leadData = response.filter(item => {
          const itemMonth = new Date(item.enquiry_date).getMonth() + 1;
          return itemMonth === parseInt(month.value) &&
            item.lead_responsible_person.includes(userId);
        });

        // Count Meetings for the user
        const meetingData = response.filter(item => {
          const itemMonth = item.last_meeting_date
            ? new Date(item.last_meeting_date).getMonth() + 1
            : null;
          return itemMonth === parseInt(month.value) &&
            item.meeting_responsible_person &&
            item.meeting_responsible_person.includes(userId);
        });

        const totalLeads = leadData.length;
        const totalMeetings = meetingData.length;
        const percentage = totalLeads > 0 ? ((totalMeetings / totalLeads) * 100).toFixed(2) : 0;

        row[user.name] = totalLeads;
        row[`site_visit_${user.name}`] = totalMeetings;
        row[`percentage_${user.name}`] = percentage;
      });

      return row;
    });

    const series = [
      {
        name: "Leads",
        data: tableData.map(row =>
          filteredUserOptions.reduce((sum, user) => sum + (row[user.name] || 0), 0)
        )
      },
      {
        name: "Site Visits",
        data: tableData.map(row =>
          filteredUserOptions.reduce((sum, user) => sum + (row[`site_visit_${user.name}`] || 0), 0)
        )
      }
    ];
    return { tableData, series };
  };

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },
      this.fetchApi(this.state.filters, this.onSuccess, this.onFail));
  };

  render() {
    const { exportData, filters, isFilterOpen, inApiCall, userOptions, tableData, series } = this.state;
    let selectedUserId, filteredprojectOptions;
    filters.map(filter => filter.field === 'responsible_person' ? selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredprojectOptions = userOptions.filter(user => {
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
    const totalRow = {
      month: "Total",
    };

    filteredprojectOptions.forEach((person) => {
      const totalLeads = tableData.reduce((sum, row) => sum + (row[person.name] || 0), 0);
      const totalMeetings = tableData.reduce((sum, row) => sum + (row[`site_visit_${person.name}`] || 0), 0);
      const percentage = totalLeads > 0 ? ((totalMeetings / totalLeads) * 100).toFixed(2) : 0;

      totalRow[person.name] = totalLeads;
      totalRow[`site_visit_${person.name}`] = totalMeetings;
      totalRow[`percentage_${person.name}`] = `${percentage}%`;
    });
    const table = (
      <Table bordered hover>
        <thead>
          <tr>
            <th>Months</th>
            {filteredprojectOptions.map((person, index) => (
              <React.Fragment key={index}>
                <th>{person.label}</th>
                <th>Site Visit</th>
                <th>Percentage (%)</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td>{row.month}</td>
              {filteredprojectOptions.map((person, idx) => (
                <React.Fragment key={`data-${idx}`}>
                  <td>{row[person.name] || 0}</td>
                  <td>{row[`site_visit_${person.name}`] || 0}</td>
                  <td>{row[`percentage_${person.name}`] || '0%'}</td>
                </React.Fragment>
              ))}
            </tr>
          ))}
          {/* Total Row */}
          <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
            <td>{totalRow.month}</td>
            {filteredprojectOptions.map((person, idx) => (
              <React.Fragment key={`total-${idx}`}>
                <td>{totalRow[person.name]}</td>
                <td>{totalRow[`site_visit_${person.name}`]}</td>
                <td>{totalRow[`percentage_${person.name}`]}</td>
              </React.Fragment>
            ))}
          </tr>
        </tbody>
      </Table>
    );


    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-7">
                  <h1>Lead To Site Visit Ratio (Sales Person Wise)</h1>
                </div>
                <div className="col-md-5">
                  <CSVLink
                    data={exportData} filename={`lead_to_site_visit_ratio_Sales Person_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                  <StackedChartComponent progressOptions={this.state.monthOptions} progressSums={series} type={"multiBar"} />
                  <div className="col-md-12">{table}</div>
                </div>
                {this.state.isFilterOpen && (
                  <FilterComplexPannel
                    filters={filters}
                    modelX={this.lead}
                    modelY={this.meeting}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={this.state.isFilterOpen}
                    restrict={this.Restrict}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}



export default LeadToSiteVisitRatioSalesExecutiveWise;
